/* ======================================================================== */
/* 31. sliderTestimonials */
/* ======================================================================== */
var SliderTestimonials = function ($scope) {

	var $target = $scope.find('.slider-testimonials[data-os-animation]'),
		tl = new TimelineMax(),
		$text = $target.find('.slider-testimonials__text, .slider-testimonials__text > *'),
		splitTestimonial = splitLines($text);

	prepare();
	animate();
	createSlider();

	function prepare() {

		if (!$target.length) {
			return;
		}

		setLines(splitTestimonial.words);

	}

	function animate() {

		if (!$target.length) {
			return;
		}

		$text.each(function () {
			var
				$el = $(this),
				$elWords = $el.find('.split-word');
			tl
				.add(animateLines($elWords), 'start');
		});

		createOSScene($target, tl);

	}

	function createSlider() {

		var $slider = $('.js-slider-testimonials');

		if (!$slider.length) {
			return;
		}

		var slider = new Swiper($slider[0], {
			autoHeight: true,
			speed: $slider.data('speed') || 800,
			autoplay: {
				enabled: $slider.data('autoplay-enabled') || false,
				delay: $slider.data('autoplay-delay') || 6000,
			},
			navigation: {
				prevEl: '.js-slider-testimonials__arrow-prev',
				nextEl: '.js-slider-testimonials__arrow-next'
			},
			pagination: {
				el: '.js-slider-testimonials__dots',
				type: 'bullets',
				bulletElement: 'div',
				clickable: true,
				bulletClass: 'slider__dot',
				bulletActiveClass: 'slider__dot_active'
			},
			simulateTouch: false
		});

		renderSliderCounter(
			slider,
			'.js-slider-testimonials-counter-current',
			'slider-testimonials__counter-current',
			'.js-slider-testimonials-counter-total'
		);

	}

}
